<template>
	<v-row justify="center">
		<v-dialog v-model="dialog"
		          max-width="400"
		          persistent
		          :content-class="classes"
		>
			<v-card>
				<v-card-title class="headline">{{ header }}</v-card-title>
				
				<v-card-text align="center" align-self="bottom">{{ message }}</v-card-text>
				
				<v-card-actions>
					<div class="flex-grow-1"></div>
					<v-btn text
					       @click="$emit('close')"
					>{{ $t("general.no") }}
					</v-btn>
					<v-btn text
					       @click="$emit(`${action}`)"
					>{{ $t("general.yes") }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>

    export default {
        props: {
            dialog: {
                type: Boolean,
                default: false
            },
            color: {
                type: String,
                default: '#00c853'
            },
            header: {
                type: String,
            },
            message: {
                type: String
            },
            action: {
                type: String,
                default: ''
            },
            styleClass: {
                type: String,
                default: 'fail'
            }
        },
        computed: {
            classes() {
                return `confirm_dialog ${this.styleClass}`;
            }
        },
        data() {
            return {}
        },
    };
</script>
